import { render } from "./BoardHead.vue?vue&type=template&id=0e4c2d4c&scoped=true"
import script from "./BoardHead.vue?vue&type=script&lang=js"
export * from "./BoardHead.vue?vue&type=script&lang=js"

import "./BoardHead.vue?vue&type=style&index=0&id=0e4c2d4c&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4c2d4c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
